const quoteBlocks = document.querySelectorAll('.abdelmeged-mobile-single-body__content blockquote');

const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.inset = '0 auto auto 0';
  textarea.style.opacity = '0';
  document.body.append(textarea);
  textarea.select();
  document.execCommand('copy');
  textarea.remove();
};

const quoteText = (blockquote) => {
  const clone = blockquote.cloneNode(true);
  clone.querySelectorAll('[data-copy-quote]').forEach((button) => button.remove());

  return clone.textContent.trim();
};

quoteBlocks.forEach((blockquote) => {
  const text = quoteText(blockquote);

  if (text === '') {
    return;
  }

  const button = document.createElement('button');
  button.className = 'abdelmeged-copy-quote__button';
  button.type = 'button';
  button.dataset.copyQuote = '';
  button.setAttribute('aria-label', 'نسخ الاقتباس');
  button.innerHTML = '<i class="fa-regular fa-copy" aria-hidden="true"></i>';

  blockquote.classList.add('abdelmeged-copy-quote');
  blockquote.append(button);

  button.addEventListener('click', async () => {
    try {
      await copyText(text);
      button.classList.add('is-copied');
      button.setAttribute('aria-label', 'تم النسخ');
      window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'copy' } }));
      window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', 'نسخ الاقتباس');
      }, 1800);
    } catch {
      button.classList.add('is-error');
      button.setAttribute('aria-label', 'تعذر النسخ');
    }
  });
});
